import { widthPercentageToDP } from './metrics'

export const SCALE_30 = widthPercentageToDP('8%')
export const SCALE_28 = widthPercentageToDP('7.46%')
export const SCALE_24 = widthPercentageToDP('6.4%')
export const SCALE_18 = widthPercentageToDP('4.8%')
export const SCALE_16 = widthPercentageToDP('4.26%')
export const SCALE_12 = widthPercentageToDP('3.2%')
export const SCALE_8 = widthPercentageToDP('2.13%')
